import { StealCardDto } from "../../../../../../networking/data/responses/steal/StealCardDto";
import { GuestInfo } from "../commonData/GuestInfo";

export class StealCard {
    public readonly stealAmountInCoins: number;
    public readonly guest: GuestInfo;
    public readonly willBeChosen: boolean;

    public constructor(dto: StealCardDto) {
        if (dto.willBeChosen == undefined) {
            throw new Error(`Failed to create StealCard with willBeChosen: ${dto.willBeChosen}.`);
        }
        if (isNaN(dto.stealAmountInCoins)) {
            throw new Error(`Failed to create StealCard with stealAmountInCoins: ${dto.stealAmountInCoins}.`);
        }
        if (dto.guest == undefined) {
            throw new Error(`Failed to create StealCard with guest: ${dto.guest}.`);
        }
        this.stealAmountInCoins = dto.stealAmountInCoins;
        this.guest = new GuestInfo(dto.guest);
        this.willBeChosen = dto.willBeChosen;
    }
}